<div class="externe-daten">
  <cap-content-header>
    <cap-title class="externe-daten">
      {{ "gwrBauprojekt.SucheTitel" | translate }}
    </cap-title>
  </cap-content-header>

  <ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
    <li [ngbNavItem]="searchModeEnum.searchStandard">
      <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
      <ng-template id="standard" ngbNavContent>
        <cap-gwr-bauprojekt-suche-standard></cap-gwr-bauprojekt-suche-standard>
      </ng-template>
    </li>

    <li [ngbNavItem]="searchModeEnum.searchDossiernummer">
      <a ngbNavLink>{{ "Dossiernummer" | translate }}</a>
      <ng-template id="dossiernummer" ngbNavContent>
        <cap-gwr-bauprojekt-suche-dossiernummer></cap-gwr-bauprojekt-suche-dossiernummer>
      </ng-template>
    </li>

    <li [ngbNavItem]="searchModeEnum.searchFachId">
      <a ngbNavLink>{{ "EPROID" | translate }}</a>
      <ng-template id="eproid" ngbNavContent>
        <cap-gwr-bauprojekt-suche-eproid></cap-gwr-bauprojekt-suche-eproid>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
